


































































import { Component, Vue, Prop, Emit, Watch } from "vue-property-decorator";
import MessageList from "./List.vue";
import Dashboard from "@/store/dashboard";

@Component({
  components: {
    "message-list": MessageList
  }
})
export default class AppDashboard extends Vue {
  tab: any = null;
  summary: any = {};

  mounted() {
    this.getSummary();
  }

  async getSummary() {
    const res = await Dashboard.summary();
    const summary = res.response.data;
    this.summary = summary;
  }

  get getTotal() {
    return this.summary && this.summary.total ? this.summary.total : 0;
  }

  get getError() {
    return this.summary && this.summary.error ? this.summary.error : 0;
  }

  get getTps() {
    return this.summary && this.summary.tps ? this.summary.tps : 0;
  }
}
